module.exports = __webpack_public_path__ + "static/img/all-banner3.165d44d.png";


//////////////////
// WEBPACK FOOTER
// ./static/pawnProducts/all-banner3.png
// module id = pcOi
// module chunks = 1